module.exports = __webpack_public_path__ + "static/media/dashboard-mockup.a3a310ae.png";